import { ProjectTabDto } from '../api_client/parameter_api';

export const updateLocalTabs = (projectSlug: string, tabs: Array<ProjectTabDto>, isHidden: boolean) => {
  if (isHidden) {
    const updatedTabIds = tabs.map(tab => tab.id as number);
    localStorage.setItem(projectSlug, JSON.stringify(updatedTabIds));
  } else {
    localStorage.removeItem(projectSlug);
  }
};
